<svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H13V9H1V1Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.96631 3.92017L10.9999 5.80017" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.0336 3.92017L3 5.80017" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.8026 1.27393L7.729 4.77259C7.51467 4.92057 7.26038 4.99983 6.99993 4.99983C6.73948 4.99983 6.4852 4.92057 6.27087 4.77259L1.19727 1.27393" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
